import React from "react";

// Member-suggestion dropdown for custom composers. Rendered just above the input.
export default function MentionDropdown({ results, onPick }) {
  if (!results || results.length === 0) return null;
  return (
    <div data-testid="mention-list" className="absolute bottom-full left-0 mb-2 z-[90] w-64 max-h-56 overflow-y-auto rounded-xl border border-line bg-surface-2 shadow-lg">
      {results.map((mem) => (
        <button
          type="button"
          key={mem.user_id}
          data-testid={`mention-opt-${mem.user_id}`}
          onClick={() => onPick(mem)}
          className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-surface-3"
        >
          {mem.avatar_url
            ? <img src={mem.avatar_url} alt="" className="w-7 h-7 rounded-full object-cover" />
            : <span className="w-7 h-7 rounded-full bg-brand-tint text-brand-tint-ink text-xs flex items-center justify-center">{(mem.full_name || "?")[0]}</span>}
          <span className="min-w-0">
            <span className="block text-sm text-ink truncate">{mem.full_name}</span>
            {mem.title && <span className="block text-xs text-muted-foreground truncate">{mem.title}</span>}
          </span>
        </button>
      ))}
    </div>
  );
}
